import { render } from "./GameHistory.vue?vue&type=template&id=17bb1c1a&scoped=true"
import script from "./GameHistory.vue?vue&type=script&lang=js"
export * from "./GameHistory.vue?vue&type=script&lang=js"

import "./GameHistory.vue?vue&type=style&index=0&id=17bb1c1a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17bb1c1a"]])

export default __exports__